import * as React from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const FilledAlert = ({ severity, message }) => {
  return (
    <Stack sx={{ width: '100%' ,fontFamily: "DM Sans, sans-serif" }} spacing={2}>
      <Alert variant="filled" severity={severity} style={{fontFamily: "DM Sans, sans-serif"}}>
        {message}
      </Alert>
    </Stack>
  );
};

export default FilledAlert;
